import { useContext } from 'react';
import { HeaderContext } from '@/contexts/HeaderContext';

const HEADER_HEIGHT = 64;
const STICKY_GAP_VISIBLE = 8;

interface HeaderContextValue {
  isHeaderVisible: boolean;
  headerHeight: number;
  stickyTop: number;
  isAtTop: boolean;
}

export function useHeader(): HeaderContextValue {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
}

/**
 * HeaderProviderの外で使う場合のフォールバック
 * （エラーを投げずにデフォルト値を返す）
 */
export function useHeaderSafe(): HeaderContextValue {
  const context = useContext(HeaderContext);
  return (
    context ?? {
      isHeaderVisible: true,
      headerHeight: HEADER_HEIGHT,
      stickyTop: HEADER_HEIGHT + STICKY_GAP_VISIBLE,
      isAtTop: true,
    }
  );
}
